define("shared/components/shared/address-fields/country", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/object", "@ember/service", "@ember/utils", "shared/utils/country-list"], function (_exports, _component, _templateFactory, _component2, _object, _service, _utils, _countryList) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/object",0,"@ember/service",0,"@ember/utils",0,"shared/utils/country-list",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <PowerSelect
    data-test-id="country-select"
    class={{if (or this.showEmptyError (is-present this.suggestion)) "ember-basic-dropdown--hasError"}}
    @disabled={{@isDisabled}}
    @dropdownClass="qa--address_country__list"
    @triggerClass="qa--address_country__dropdown"
    @placeholder={{t "account.subscription.billing.address.country"}}
    @selected={{this.selectedCountry}}
    @renderInPlace={{true}}
    @searchEnabled={{true}}
    @searchField="name"
    @searchPlaceholder={{t "shared_words.search"}}
    @options={{this.countryList}}
    @onChange={{this.updateSelectedCountry}}
    {{on "click" this.addSearchClass}}
    as |country|
  >
    <span data-test-id="country-option">
      {{country.name}}
    </span>
  </PowerSelect>
  <Shared::AddressFields::Error
    @emptyText={{t "errors.address.empty.country"}}
    @field={{@field}}
    @missingValue={{this.showEmptyError}}
    @suggestion={{this.suggestion}}
  />
  */
  {
    "id": "o2W8vij/",
    "block": "[[[8,[39,0],[[24,\"data-test-id\",\"country-select\"],[16,0,[52,[28,[37,2],[[30,0,[\"showEmptyError\"]],[28,[37,3],[[30,0,[\"suggestion\"]]],null]],null],\"ember-basic-dropdown--hasError\"]],[4,[38,5],[\"click\",[30,0,[\"addSearchClass\"]]],null]],[[\"@disabled\",\"@dropdownClass\",\"@triggerClass\",\"@placeholder\",\"@selected\",\"@renderInPlace\",\"@searchEnabled\",\"@searchField\",\"@searchPlaceholder\",\"@options\",\"@onChange\"],[[30,1],\"qa--address_country__list\",\"qa--address_country__dropdown\",[28,[37,4],[\"account.subscription.billing.address.country\"],null],[30,0,[\"selectedCountry\"]],true,true,\"name\",[28,[37,4],[\"shared_words.search\"],null],[30,0,[\"countryList\"]],[30,0,[\"updateSelectedCountry\"]]]],[[\"default\"],[[[[1,\"\\n  \"],[10,1],[14,\"data-test-id\",\"country-option\"],[12],[1,\"\\n    \"],[1,[30,2,[\"name\"]]],[1,\"\\n  \"],[13],[1,\"\\n\"]],[2]]]]],[1,\"\\n\"],[8,[39,6],null,[[\"@emptyText\",\"@field\",\"@missingValue\",\"@suggestion\"],[[28,[37,4],[\"errors.address.empty.country\"],null],[30,3],[30,0,[\"showEmptyError\"]],[30,0,[\"suggestion\"]]]],null]],[\"@isDisabled\",\"country\",\"@field\"],false,[\"power-select\",\"if\",\"or\",\"is-present\",\"t\",\"on\",\"shared/address-fields/error\"]]",
    "moduleName": "shared/components/shared/address-fields/country.hbs",
    "isStrictMode": false
  });

  let Country = (_class = class Country extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "address", _descriptor, this);

      _initializerDefineProperty(this, "intl", _descriptor2, this);

      _defineProperty(this, "countryList", (0, _countryList.default)(this.intl));
    }

    get showEmptyError() {
      return this.args.showErrors && !(0, _utils.isPresent)(this.selectedCountry);
    }

    get selectedCountry() {
      return this.countryList.find(country => country.code === this.args.country) || '';
    }

    get suggestion() {
      return this.args.suggestions.find(item => item.key === this.args.field);
    }

    addSearchClass() {
      const search = document.getElementsByClassName('ember-power-select-search-input');
      search[0].classList.add('qa--address_country__input');
    }

    updateSelectedCountry(_ref2) {
      let {
        code
      } = _ref2;
      this.address.resetValidation();
      this.args.setSelectedCountry(code);
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "address", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "addSearchClass", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "addSearchClass"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateSelectedCountry", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateSelectedCountry"), _class.prototype)), _class);
  _exports.default = Country;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, Country);
});